import React from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/logo.png";

export const Bookmark = () => {
  return <div className="bookmark" />;
};

export const NavBar = (props) => {
  return (
    <div className="home-top-bar">
      <NavLink to="/home">
        <img className="home-nav-logo" src={logo} alt="" />
      </NavLink>
      <div className="home-topnav">
        <NavLink to="/about">
          <button className="home-nav-options" type="button">
            About
          </button>
        </NavLink>

        <NavLink to="/faq">
          <button className="home-nav-options" type="button">
            FAQ
          </button>
        </NavLink>

        <NavLink to="/register">
          <button className="home-nav-options" type="button">
            Sign Up
          </button>
        </NavLink>

        <NavLink to="/admin">
          <button className="home-nav-options" type="button">
            {props.isLoggedIn === true ? "Admin" : "Sign In"}
          </button>
        </NavLink>

        {props.isLoggedIn === true ? (
          <button
            className="home-nav-options"
            type="button"
            onClick={props.logout}
          >
            Logout
          </button>
        ) : null}
      </div>
    </div>
  );
};

export const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-content">
        <NavLink to="/terms" style={{ textDecoration: "none", color: "grey" }}>
          <text className="footer-options">Terms and Conditions</text>
        </NavLink>
        <NavLink
          to="/privacy"
          style={{ textDecoration: "none", color: "grey" }}
        >
          <text className="footer-options">Privacy Policy</text>
        </NavLink>
      </div>
    </div>
  );
};

export const Logout = () => {};



// WEBPACK FOOTER //
// ./src/components/ReusableElements.js